<div class="container-lg">
  <button (click)="closeHelp()" type="button"
          class="btn btn-sm btn-light mt-3 float-end d-lg-block">{{i18n.get('global_close')}}</button>
  <h1 class="h3 pb-2 mb-2 border-bottom">{{i18n.get('global_help')}}</h1>
  <div class="accordion" id="helpAccordion">
    <ng-container *ngFor="let helpSection of helpData">
      <app-help-section [opened]="helpId === helpSection.id" [helpSection]="helpSection"></app-help-section>
    </ng-container>
  </div>
</div>
